import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import AccountSiderBar from "../../Pages/Account/AccountSideBar";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CompanyTab } from "./ApplicationTabs/CompanyTab";
import { OwnerTab } from "./ApplicationTabs/OwnerTab";
import { AuthorizedTab } from "./ApplicationTabs/AuthorizedTab";
import { TradeTab } from "./ApplicationTabs/TradeTab";
import { BankTab } from "./ApplicationTabs/BankTab";
import axios from "axios";
import Swal from "sweetalert2";
import CreditTab from "./ApplicationTabs/CreditTab";
import SecurityCheckTab from "./ApplicationTabs/SecurityCheckTab";
import { axiosGet, axiosPost } from "../../Apis/axiosMethods";

const CreditApplication = () => {
    const { t } = useTranslation();
    const { apiB2BURL, apiHeaderJson, apiHeaderFile } = useContext(ConfigContext);
    const headers = apiHeaderJson;

    const dir = localStorage.getItem("dir");

    const [activeTab, setActiveTab] = useState("company");
    const [ownerdata, setOwnerdata] = useState([
        { name: "", designation: "", nationality: null, eid_no: "" }
    ]);
    const [purchaseData, setPurchaseData] = useState([{ name: "", designation: "", nationality: null, eid_no: "" }]);
    const [chequeData, setChequeData] = useState([{ name: "", designation: "", nationality: null, eid_no: "" }]);
    const [tradeData, setTradeData] = useState([
        { trade_company: "", trade_address: "", trade_contact: "" }
    ]);
    const [securityFile, setSecurityFile] = useState(null);
    const [fileError, setFileError] = useState("");

    const [state, setState] = useState({
        company_name: "",
        company_email: "",
        company_address: "",
        telephone: "",
        fax: "",
        mobile_number: "",
        date: "",
        annual_turnover: "",
        dealing_type: 0,

        bank_name: "",
        account_number: "",
        bank_address: "",
        contact_person: "",

        // ✅ CREDIT DETAILS
        creditAmount: "",
        creditDays: "",
        financeEmail: "",
        financePhone: "",

        credit_amount_remark: "",
        credit_days_remark: ""
    });

    const [errors, setErrors] = useState({});
    const [countryList, setCountryList] = useState([]);
    const [loading, setLoading] = useState(false);

    const validateForm = () => {
        const newErrors = {}

        if (!state.company_name.trim()) {
            newErrors.company_name = "Company name is required"
        }
        if (!state.company_email.trim()) {
            newErrors.company_email = "Company email is required"
        } else if (!/\S+@\S+\.\S+/.test(state.company_email)) {
            newErrors.company_email = "Email is invalid"
        }
        if (!state.company_address.trim()) {
            newErrors.company_address = "Company address is required"
        }
        if (!state.mobile_number.trim()) {
            newErrors.mobile_number = "Mobile number is required"
        }
        if (!state.telephone.trim()) {
            newErrors.telephone = "Telephone is required"
        }
        if (!state.date.trim()) {
            newErrors.date = "Establishment date is required"
        }
        if (!state.annual_turnover.trim()) {
            newErrors.annual_turnover = "Annual turnover is required"
        }
        if (state.dealing_type === undefined || state.dealing_type === null) {
            newErrors.dealing_type = "Dealing type is required"
        }

        ownerdata.forEach((owner, index) => {
            if (!owner.name.trim()) {
                newErrors[`owner_name_${index}`] = `Owner name ${index + 1} is required`
            }
            if (!owner.designation.trim()) {
                newErrors[`owner_designation_${index}`] = `Owner designation ${index + 1} is required`
            }
            if (!owner.nationality) {
                newErrors[`owner_nationality_${index}`] = `Owner nationality ${index + 1} is required`
            }
            if (!owner.eid_no.trim()) {
                newErrors[`owner_eid_no_${index}`] = `Owner EID number ${index + 1} is required`
            }
        });

        purchaseData.forEach((order, index) => {
            if (!order.name.trim()) {
                newErrors[`purchase_name_${index}`] = `Purchase order name ${index + 1} is required`
            }
            if (!order.designation.trim()) {
                newErrors[`purchase_designation_${index}`] = `Purchase order designation ${index + 1} is required`
            }
            if (!order.nationality) {
                newErrors[`purchase_nationality_${index}`] = `Purchase order nationality ${index + 1} is required`
            }
            if (!order.eid_no.trim()) {
                newErrors[`purchase_eid_no_${index}`] = `Purchase order EID number ${index + 1} is required`
            }
        });

        chequeData.forEach((cheque, index) => {
            if (!cheque.name.trim()) {
                newErrors[`cheque_name_${index}`] = `Cheque name ${index + 1} is required`
            }
            if (!cheque.designation.trim()) {
                newErrors[`cheque_designation_${index}`] = `Cheque designation ${index + 1} is required`
            }
            if (!cheque.nationality) {
                newErrors[`cheque_nationality_${index}`] = `Cheque nationality ${index + 1} is required`
            }
            if (!cheque.eid_no.trim()) {
                newErrors[`cheque_eid_no_${index}`] = `Cheque EID number ${index + 1} is required`
            }
        });

        tradeData.forEach((trade, index) => {
            if (!trade.trade_company.trim()) {
                newErrors[`trade_company_${index}`] = `Trade company ${index + 1} is required`
            }
            if (!trade.trade_address.trim()) {
                newErrors[`trade_address_${index}`] = `Trade address ${index + 1} is required`
            }
            if (!trade.trade_contact.trim()) {
                newErrors[`trade_contact_${index}`] = `Trade contact ${index + 1} is required`
            }
        });

        if (!state.bank_name.trim()) {
            newErrors.bank_name = "Bank name is required"
        }
        if (!state.account_number.trim()) {
            newErrors.account_number = "Account number is required"
        }
        if (!state.bank_address.trim()) {
            newErrors.bank_address = "Bank address is required"
        }
        if (!state.contact_person.trim()) {
            newErrors.contact_person = "Contact person is required"
        }

        // Credit Amount
        if (!state.creditAmount || Number(state.creditAmount) <= 0) {
            newErrors.creditAmount = "Credit amount is required";
        }

        if (!state.credit_amount_remark.trim()) {
            newErrors.credit_amount_remark = "Credit amount remark is required"
        }

        if (!state.credit_days_remark.trim()) {
            newErrors.credit_days_remark = "Credit amount days remark is required"
        }

        // Credit Days
        if (!state.creditDays || Number(state.creditDays) <= 0) {
            newErrors.creditDays = "Credit days are required";
        }

        // Finance Email
        if (!state.financeEmail.trim()) {
            newErrors.financeEmail = "Finance email is required";
        } else if (!/\S+@\S+\.\S+/.test(state.financeEmail)) {
            newErrors.financeEmail = "Finance email is invalid";
        }

        // Finance Phone
        if (!state.financePhone.trim()) {
            newErrors.financePhone = "Finance phone number is required";
        } else if (!/^[0-9]{7,15}$/.test(state.financePhone)) {
            newErrors.financePhone = "Finance phone number is invalid";
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0;
    }

    const validateCompanyTab = () => {
        const newErrors = {};

        if (!state.company_name.trim()) newErrors.company_name = "Company name is required";
        if (!state.company_email.trim()) {
            newErrors.company_email = "Company email is required";
        } else if (!/\S+@\S+\.\S+/.test(state.company_email)) {
            newErrors.company_email = "Email is invalid";
        }
        if (!state.company_address.trim()) newErrors.company_address = "Company address is required";
        if (!state.mobile_number.trim()) newErrors.mobile_number = "Mobile number is required";
        if (!state.telephone.trim()) newErrors.telephone = "Telephone is required";
        if (!state.date.trim()) newErrors.date = "Establishment date is required";
        if (!state.annual_turnover.trim()) newErrors.annual_turnover = "Annual turnover is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateOwnerTab = () => {
        const newErrors = {};

        ownerdata.forEach((owner, index) => {
            if (!owner.name.trim()) newErrors[`owner_name_${index}`] = "Owner name is required";
            if (!owner.designation.trim()) newErrors[`owner_designation_${index}`] = "Designation is required";
            if (!owner.nationality) newErrors[`owner_nationality_${index}`] = "Nationality is required";
            if (!owner.eid_no.trim()) newErrors[`owner_eid_no_${index}`] = "EID is required";
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateAuthorizedTab = () => {
        const newErrors = {};

        purchaseData.forEach((p, i) => {
            if (!p.name.trim()) newErrors[`purchase_name_${i}`] = "Required";
            if (!p.designation.trim()) newErrors[`purchase_designation_${i}`] = "Required";
            if (!p.nationality) newErrors[`purchase_nationality_${i}`] = "Required";
            if (!p.eid_no.trim()) newErrors[`purchase_eid_no_${i}`] = "Required";
        });

        chequeData.forEach((c, i) => {
            if (!c.name.trim()) newErrors[`cheque_name_${i}`] = "Required";
            if (!c.designation.trim()) newErrors[`cheque_designation_${i}`] = "Required";
            if (!c.nationality) newErrors[`cheque_nationality_${i}`] = "Required";
            if (!c.eid_no.trim()) newErrors[`cheque_eid_no_${i}`] = "Required";
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateTradeTab = () => {
        const newErrors = {};

        tradeData.forEach((t, i) => {
            if (!t.trade_company.trim()) newErrors[`trade_company_${i}`] = "Required";
            if (!t.trade_address.trim()) newErrors[`trade_address_${i}`] = "Required";
            if (!t.trade_contact.trim()) newErrors[`trade_contact_${i}`] = "Required";
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateBankTab = () => {
        const newErrors = {};

        if (!state.bank_name.trim()) newErrors.bank_name = "Bank name is required";
        if (!state.account_number.trim()) newErrors.account_number = "Account number is required";
        if (!state.bank_address.trim()) newErrors.bank_address = "Bank address is required";
        if (!state.contact_person.trim()) newErrors.contact_person = "Contact person is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateCreditTab = () => {
        const newErrors = {};

        if (!state.creditAmount || Number(state.creditAmount) <= 0)
            newErrors.creditAmount = "Credit amount required";

        if (!state.creditDays || Number(state.creditDays) <= 0)
            newErrors.creditDays = "Credit days required";

        if (!state.financeEmail.trim())
            newErrors.financeEmail = "Finance email required";

        if (!state.financePhone.trim())
            newErrors.financePhone = "Finance phone required";

        if (!state.credit_amount_remark.trim())
            newErrors.credit_amount_remark = "Remark required";

        if (!state.credit_days_remark.trim())
            newErrors.credit_days_remark = "Remark required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateSecurityCheckTab = () => {
        if (!securityFile) {
            setFileError("Security check document is required");
            return false;
        }

        // Check file type
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
        if (!allowedTypes.includes(securityFile.type)) {
            setFileError("Please upload PDF, JPEG, or PNG files only");
            return false;
        }

        // Check file size (5MB limit)
        if (securityFile.size > 5 * 1024 * 1024) {
            setFileError("File size should be less than 5MB");
            return false;
        }

        setFileError("");
        return true;
    };

    const resetForm = () => {
        setActiveTab("company");
        setOwnerdata([
            { name: "", designation: "", nationality: "", eid_no: "" }
        ]);
        setPurchaseData([
            { name: "", designation: "", nationality: "", eid_no: "" }
        ]);
        setChequeData([
            { name: "", designation: "", nationality: "", eid_no: "" }
        ]);
        setTradeData([
            { trade_company: "", trade_address: "", trade_contact: "" }
        ]);
        setSecurityFile(null);
        setFileError("");

        setState({
            company_name: "",
            company_email: "",
            company_address: "",
            telephone: "",
            fax: "",
            mobile_number: "",
            date: "",
            annual_turnover: "",
            dealing_type: 0,
            bank_name: "",
            account_number: "",
            bank_address: "",
            contact_person: "",
            creditAmount: "",
            creditDays: "",
            financeEmail: "",
            financePhone: "",
            credit_amount_remark: "",
            credit_days_remark: ""
        });

        setErrors({});
        setLoading(false);
    };

    const tabOrder = ["company", "owner", "authorized", "trade", "bank", "credit", "security"];

    const handleTabChange = (nextTab) => {
        const currentIndex = tabOrder.indexOf(activeTab);
        const nextIndex = tabOrder.indexOf(nextTab);

        if (nextIndex < currentIndex) {
            setErrors({});
            setActiveTab(nextTab);
            return;
        }

        let isValid = true;

        switch (activeTab) {
            case "company":
                isValid = validateCompanyTab();
                break;
            case "owner":
                isValid = validateOwnerTab();
                break;
            case "authorized":
                isValid = validateAuthorizedTab();
                break;
            case "trade":
                isValid = validateTradeTab();
                break;
            case "bank":
                isValid = validateBankTab();
                break;
            case "credit":
                isValid = validateCreditTab();
                break;
            case "security":
                isValid = validateSecurityCheckTab();
                break;
            default:
                break;
        }

        if (!isValid) {
            Swal.fire("Warning", "All fields in this section must be filled to move forward", "warning");
            return;
        }

        setErrors({});
        setActiveTab(nextTab);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (errors[name]) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [name]: ""
            }));
        }
    };

    const handleCheckboxChange = (e) => {
        const { value } = e.target;
        setState(prevState => ({
            ...prevState,
            dealing_type: parseInt(value)
        }));

        if (errors.dealing_type) {
            setErrors(prevErrors => ({
                ...prevErrors,
                dealing_type: ""
            }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSecurityFile(file);
        if (fileError) setFileError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate all tabs including security
        if (!validateForm() || !validateSecurityCheckTab()) {
            Swal.fire("Error", "Please fill all required fields and upload security document", "error");
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();

            // Append all form data
            Object.keys(state).forEach(key => {
                formData.append(key, state[key]);
            });

            // Append arrays
            ownerdata.forEach((owner, index) => {
                formData.append(`owners[${index}][name]`, owner.name);
                formData.append(`owners[${index}][designation]`, owner.designation);
                formData.append(`owners[${index}][nationality]`, owner.nationality?.label || "");
                formData.append(`owners[${index}][eid_no]`, owner.eid_no);
            });

            purchaseData.forEach((purchase, index) => {
                formData.append(`purchase_orders[${index}][name]`, purchase.name);
                formData.append(`purchase_orders[${index}][designation]`, purchase.designation);
                formData.append(`purchase_orders[${index}][nationality]`, purchase.nationality?.label || "");
                formData.append(`purchase_orders[${index}][eid_no]`, purchase.eid_no);
            });

            chequeData.forEach((cheque, index) => {
                formData.append(`cheques[${index}][name]`, cheque.name);
                formData.append(`cheques[${index}][designation]`, cheque.designation);
                formData.append(`cheques[${index}][nationality]`, cheque.nationality?.label || "");
                formData.append(`cheques[${index}][eid_no]`, cheque.eid_no);
            });

            tradeData.forEach((trade, index) => {
                formData.append(`trades[${index}][trade_company]`, trade.trade_company);
                formData.append(`trades[${index}][trade_address]`, trade.trade_address);
                formData.append(`trades[${index}][trade_contact]`, trade.trade_contact);
            });

            // Append file
            if (securityFile) {
                formData.append("business_credit_application_security_check", securityFile);
            }

            const response = await axiosPost(`/Dashboard/RequestCreditForm`, formData, apiHeaderFile);

            const { success, message } = response.data;

            if (success) {
                Swal.fire({
                    title: "Success!",
                    text: message,
                    icon: "success",
                    confirmButtonText: "OK"
                }).then(() => {
                    resetForm();
                });
            } else {
                Swal.fire("Error", message, "error");
            }
        } catch (error) {
            console.log("Error submitting form", error);
            Swal.fire("Error", "Failed to submit application. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };

    const getCountryList = async () => {
        try {
            const response = await axiosGet(`/Dashboard/GetCountries`, { headers });
            const { success, data } = response.data;
            if (success) {
                const options = data.map(country => ({
                    value: country.country_id,
                    label: country.country
                }));
                setCountryList(options);
            }
        } catch (error) {
            console.log("Error fetching country list:", error)
        }
    };

    useEffect(() => {
        getCountryList();
    }, []);

    return (
        <main style={{ marginTop: '-10px' }}>
            <div className="page-header">
                <div className="container d-flex flex-column align-items-center">
                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb" dir={dir}>
                                <li className="breadcrumb-item">
                                    <NavLink to={"/"}>{t("home")}</NavLink>
                                </li>
                                <li className="breadcrumb-item">
                                    <NavLink to={`/MyAccount`}>{t("my_account")}</NavLink>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    {t("Credit Application")}
                                </li>
                            </ol>
                        </div>
                    </nav>
                    <h1>{t("Credit Application")}</h1>
                </div>
            </div>

            <div className="container account-container custom-account-container">
                <div className="row">
                    <AccountSiderBar />
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title text-center mb-0">Credit Application Form</h5>
                            </div>
                            <div className="card-body">
                                <form className="form-steps mb-0" autoComplete="off" onSubmit={handleSubmit}>
                                    {/* Nav Tabs */}
                                    <div className="text-center mb-4">
                                        <div className="d-flex flex-wrap justify-content-evenly align-items-center gap-2">
                                            {/* Company Tab */}
                                            <button
                                                type="button"
                                                className={`btn btn-outline-primary btn-sm ${activeTab === "company" ? "active" : ""}`}
                                                onClick={() => handleTabChange("company")}
                                            >
                                                Company
                                            </button>
                                            <ArrowForwardIosIcon className="text-secondary small" />

                                            {/* Owner Tab */}
                                            <button
                                                type="button"
                                                className={`btn btn-outline-primary btn-sm ${activeTab === "owner" ? "active" : ""}`}
                                                onClick={() => handleTabChange("owner")}
                                            >
                                                Owner/Partner
                                            </button>
                                            <ArrowForwardIosIcon className="text-secondary small" />

                                            {/* Authorized Tab */}
                                            <button
                                                type="button"
                                                className={`btn btn-outline-primary btn-sm ${activeTab === "authorized" ? "active" : ""}`}
                                                onClick={() => handleTabChange("authorized")}
                                            >
                                                Authorized Signature
                                            </button>
                                            <ArrowForwardIosIcon className="text-secondary small" />

                                            {/* Trade Tab */}
                                            <button
                                                type="button"
                                                className={`btn btn-outline-primary btn-sm ${activeTab === "trade" ? "active" : ""}`}
                                                onClick={() => handleTabChange("trade")}
                                            >
                                                Trade Reference
                                            </button>
                                            <ArrowForwardIosIcon className="text-secondary small" />

                                            {/* Bank Tab */}
                                            <button
                                                type="button"
                                                className={`btn btn-outline-primary btn-sm ${activeTab === "bank" ? "active" : ""}`}
                                                onClick={() => handleTabChange("bank")}
                                            >
                                                Bank Details
                                            </button>
                                            <ArrowForwardIosIcon className="text-secondary small" />

                                            {/* Credit Tab */}
                                            <button
                                                type="button"
                                                className={`btn btn-outline-primary btn-sm ${activeTab === "credit" ? "active" : ""}`}
                                                onClick={() => handleTabChange("credit")}
                                            >
                                                Credit Details
                                            </button>
                                            <ArrowForwardIosIcon className="text-secondary small" />

                                            {/* Security Check Tab */}
                                            <button
                                                type="button"
                                                className={`btn btn-outline-primary btn-sm ${activeTab === "security" ? "active" : ""}`}
                                                onClick={() => handleTabChange("security")}
                                            >
                                                Security Cheque
                                            </button>
                                        </div>
                                    </div>

                                    {/* Tab Contents */}
                                    <div className="tab-content">
                                        {activeTab === "company" && (
                                            <CompanyTab
                                                state={state}
                                                errors={errors}
                                                handleInputChange={handleInputChange}
                                                handleCheckboxChange={handleCheckboxChange}
                                                handleTabChange={handleTabChange}
                                            />
                                        )}
                                        {activeTab === "owner" && (
                                            <OwnerTab
                                                ownerdata={ownerdata}
                                                setOwnerdata={setOwnerdata}
                                                errors={errors}
                                                setErrors={setErrors}
                                                handleTabChange={handleTabChange}
                                                countryList={countryList}
                                            />
                                        )}

                                        {activeTab === "authorized" && (
                                            <AuthorizedTab
                                                purchaseData={purchaseData}
                                                setPurchaseData={setPurchaseData}
                                                chequeData={chequeData}
                                                setChequeData={setChequeData}
                                                errors={errors}
                                                setErrors={setErrors}
                                                handleTabChange={handleTabChange}
                                                countryList={countryList}
                                            />
                                        )}

                                        {activeTab === "trade" && (
                                            <TradeTab
                                                tradeData={tradeData}
                                                setTradeData={setTradeData}
                                                errors={errors}
                                                setErrors={setErrors}
                                                handleTabChange={handleTabChange}
                                            />
                                        )}

                                        {activeTab === "bank" && (
                                            <BankTab
                                                state={state}
                                                errors={errors}
                                                handleInputChange={handleInputChange}
                                                handleTabChange={handleTabChange}
                                            />
                                        )}

                                        {activeTab === "credit" && (
                                            <CreditTab
                                                handleTabChange={handleTabChange}
                                                state={state}
                                                errors={errors}
                                                handleInputChange={handleInputChange}
                                            />
                                        )}

                                        {activeTab === "security" && (
                                            <SecurityCheckTab
                                                handleTabChange={handleTabChange}
                                                securityFile={securityFile}
                                                handleFileChange={handleFileChange}
                                                fileError={fileError}
                                                handleSubmit={handleSubmit}
                                                loading={loading}
                                            />
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default CreditApplication;